/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  Typography,
  Divider,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import Actions from "../../../fluid/Actions/ActionFactory.js";
import ErrorMessageAlert from "../../Utilities/ErrorMessageAlert";
import FDropDown from "../../../fluid/Elements/Inputs/FDropDown";
import AddWebService from "../../WebService/AddWebService";

const styles = (theme) => ({
  text_field: {
    width: "100%",
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

const INITIAL_HELPER_TEXTS = {
    security_adaptor_name_helper_text: "Choose a Unique name for the Security Adaptor",
    security_adaptor_description_helper_text: "Write a description for the Security Adaptor",
    ws_helper_text: "Select Edge Service",
    security_adaptor_key_helper_text: "Choose a key for the Security Adaptor",
  };
  

class CreateSecurityAdaptor extends Component {
    state = {
        security_adaptor_name: "",
        security_adaptor_name_error: false,
        security_adaptor_name_helper_text: INITIAL_HELPER_TEXTS.security_adaptor_name_helper_text,

        security_adaptor_description: "",
        security_adaptor_description_error: false,
        security_adaptor_description_helper_text: INITIAL_HELPER_TEXTS.security_adaptor_description_helper_text,

        ws: "",
        ws_error: false,
        ws_helper_text: INITIAL_HELPER_TEXTS.ws_helper_text,

        security_adaptor_key: "",
        security_adaptor_key_error: false,
        security_adaptor_key_helper_text: INITIAL_HELPER_TEXTS.security_adaptor_key_helper_text,

        // security_adaptor_name: "",
        // ssecurity_adaptor_name_error: "",
        // security_adaptor_name_helper_text: "Provide a url for the Script",

        // script_location: "",
        // script_location_error: "",
        // script_location_helper_text: "Provide a location for the Script",
        error: false,
        error_message: null,
        errorOpen: false,
        errorInfo: {},
        security_adaptor_details: null,
        edit_mode: false,
    };

    componentDidMount = () => {
        // if (this.props.script_details !== null) {
        //     this.setSecurityAdaptorParams();
        // }
    };

    handleChange = (value, state_key) => {
        this.setState(
        {
            ...this.state,
            [state_key]: value,
        },
        () => {
            console.log("Create IU State: ", this.state);
        }
        );
    };

    validateField = (field) => {
        if (this.state[field] !== "") {
        let error = false;
        this.setState({ [field + "_error"]: error });
        return true;
        } else {
        let error = true;
        this.setState({ [field + "_error"]: error });
        return false;
        }
    };

    //commenting code for edit mode
    //   validateAndProceed = () => {
    //     let security_adaptor_details_create_step = {
    //       name: this.state.security_adaptor_name,
    //       //title: this.state.script_title,
    //       description: this.state.security_adaptor_description,
    //       //host_name: this.state.script_host_name,
    //       //script_location: this.state.script_location,
    //     };

    //     let { edit_mode } = this.state;

    //     if (edit_mode === true) {
    //       let { security_adaptor_details } = this.state;
    //       let {
    //         name,
    //         //title,
    //         description,
    //         //host_name,
    //         //script_location,
    //       } = security_adaptor_details_create_step;

    //       security_adaptor_details.name = name;
    //       //security_adaptor_details.title = title;
    //       security_adaptor_details.description = description;
    //       //script_details.host_name = host_name;
    //       //script_details.script_location = script_location;

    //       this.setState({ ...this.state, security_adaptor_details: security_adaptor_details }, () => {
    //           this.CreateSecurityAdaptor();
    //         // this.props.handleNext({
    //         //     security_adaptor_name: this.state.security_adaptor_name,
    //         //     security_adaptor_details: this.state.security_adaptor_details,
    //         // });
    //       });
    //     } else {
    //       this.setState(
    //         { ...this.state, security_adaptor_details: security_adaptor_details_create_step },
    //         () => {
    //           this.props.handleNext({
    //             security_adaptor_name: this.state.security_adaptor_name,
    //             security_adaptor_details: this.state.security_adaptor_details,
    //           });
    //         }
    //       );
    //     }
    //   };

    validateField = (field) => {
        console.log("validate workflow", this.state[field]);
        if (this.state[field] !== "") {
          let error = false;
          this.setState({ [field + "_error"]: error });
          this.setState({
            [field + "_helper_text"]: INITIAL_HELPER_TEXTS[field + "_helper_text"],
          });
          return true;
        } else {
          let error = true;
          this.setState({ [field + "_error"]: error });
          this.setState({
            [field + "_helper_text"]: "Field value cannot be empty",
          });
          return false;
        }
    };
    
    validateAllFields = () => {
        let fields = [
            "security_adaptor_name",
            "security_adaptor_description",
            "ws",
            "security_adaptor_key"
        ];
        let field_validation = fields.map((field) => {
            return this.validateField(field);
        });

        if (field_validation.filter((field) => field === false).length === 0) {
            return true;
        } else {
            return false;
        }
    };


    validateAndCreateSecurityAdaptor = () => {
        if (this.validateAllFields() === true) {
            this.CreateSecurityAdaptor();
        }
    }

    CreateSecurityAdaptor = () => {
        Actions("http_request", {
            url: "/sainapse/security_adapter",
            method: "post",
            data: {
                name: this.state.security_adaptor_name,
                description: this.state.security_adaptor_description,
                web_service: {
                    name: this.state.ws,
                },
                key: this.state.security_adaptor_key,
                setup_complete: false
            }
        }).then((res) => {
            console.log("wf res", res);
            this.setState({ ...this.state, security_adaptor_name: res.data.result.name }, () =>
                this.props.handleNext({
                    security_adaptor_name: this.state.security_adaptor_name
                })
            );
        })
        .catch((err) => {
        let response = err.response.data;
        /*if (Array.isArray(response.errors)) {
            response.errors.map((error) => {
            this.setState({
                ...this.state,
                ["security_adaptor_" + error.attribute + "_error"]: true,
                ["security_adaptor_" + error.attribute + "_helper_text"]: error.message,
                error: false,
                error_message: null,
            });
            });
        } else {*/
            this.setState({
            ...this.state,
            error: true,
            error_message: response,
            });
        //}
        });
    }

    renderSecurityAdaptorsKeyDropDown = () => {
        if (this.state.ws !== "" && this.state.ws !== null) {
          return (
            <div style={{ width: "100%" }}>
              <FDropDown
                instance={{
                  label: "Security Adaptor Key",
                  helper_text: this.state.security_adaptor_key_helper_text,
                  props: {
                    width: "100",
                    variant: "standard",
                  },
                  value_store: ["security_adaptor_key"],
                  eval_value: "",
                  error: this.state.security_adaptor_key_error,
                  async_values: true,
                  api_config: {
                    args: {
                      url: "/sainapse/web_service/" + this.state.ws + "/security_adapter",
                      method: "get",
                      data: {},
                    },
                    response_key: "result",
                    val_key: "key",
                    label_key: "",
                  },
                  values: [],
                  render_condition: "",
                  mandatory: true,
                  onBlur: () => this.validateField("security_adaptor_key"),
                }}
                handleChange={(state_key, value) => {
                  this.handleChange(value, state_key[0]);
                  //this.getAdaptors(value)
                }}
              />
            </div>
          );
        }
    };
    
    closeWebServiceDialog = () => {
        this.setState({ ...this.state, add_web_service: false });
    };
    
    openWebServiceDialog = () => {
        this.setState({ ...this.state, add_web_service: true });
    };
    
    closeError = () => {
        this.setState({ ...this.state, error: false, error_message: null });
    };




    render() {
        const { classes } = this.props;
        return (
            <div
                style={{
                width: "100%",
                height: this.props.maxHeight,
                backgroundColor: "#F0F0F0",
                display: "flex",
                flexDirection: "row",
                justifyItems: "center",
                alignItems: "center",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        // height: this.props.maxHeight,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: this.state.content_height,
                        maxHeight: this.state.content_height,
                        overflow: "scroll",
                        padding: "8px",
                    }}
                >
                    <Paper
                        elevation={4}
                        style={{
                        padding: "10px",
                        width: "60%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        }}
                    >
                        <div style={{ width: "100%" }}>
                            <Typography variant="h6">Create Security Adaptor</Typography>
                            <Divider style={{ marginTop: "5px", marginBottom: "10px" }} />
                        </div>
                        <ThemeProvider theme={blue_theme}>
                            <TextField
                                key="security_adaptor_name"
                                className={classes.text_field}
                                disabled={this.state.edit_mode === true}
                                name="Security Adaptor Name"
                                defaultValue=""
                                multiline={false}
                                label="Security Adaptor Name"
                                value={this.state.security_adaptor_name}
                                error={this.state.security_adaptor_name_error}
                                type="string"
                                required={true}
                                variant="standard"
                                size="small"
                                helperText={this.state.security_adaptor_name_helper_text}
                                onChange={(event) =>
                                this.handleChange(event.target.value, "security_adaptor_name")
                                }
                                onBlur={() => this.validateField("security_adaptor_name")}
                            />

                

                            <TextField
                                key="security_adaptor_description"
                                className={classes.text_field}
                                disabled={this.state.submission}
                                name="Security Adaptor Description"
                                defaultValue=""
                                multiline={true}
                                rowsMax="4"
                                label="Security Adaptor Description"
                                value={this.state.security_adaptor_description}
                                error={this.state.security_adaptor_description_error}
                                type="string"
                                required={true}
                                variant="standard"
                                size="small"
                                helperText={this.state.security_adaptor_description_helper_text}
                                onChange={(event) =>
                                this.handleChange(event.target.value, "security_adaptor_description")
                                }
                                onBlur={() => this.validateField("security_adaptor_description")}
                            />

                            <div style={{ width: "100%" }}>
                                <FDropDown
                                instance={{
                                    label: "Edge Service",
                                    helper_text: this.state.ws_helper_text,
                                    props: {
                                    width: "100",
                                    variant: "standard",
                                    },
                                    value_store: ["ws"],
                                    eval_value: "",
                                    error: this.state.ws_error,
                                    default_value: "",
                                    async_values: true,
                                    api_config: {
                                    args: {
                                        url: "/sainapse/web_service",
                                        method: "get",
                                        data: {},
                                    },
                                    response_key: "result",
                                    val_key: "name",
                                    label_key: "",
                                    },
                                    values: [],
                                    render_condition: "",
                                    mandatory: true,
                                    onBlur: () => this.validateField("ws"),
                                }}
                                handleChange={(state_key, value) => {
                                    this.handleChange(value, state_key[0]);
                                    //this.getAdaptors(value)
                                }}
                                />

                                
                            </div>

                            { this.renderSecurityAdaptorsKeyDropDown() }

                
                            <ThemeProvider theme={blue_theme}>
                                <Button
                                style={{ marginTop: "20px" }}
                                fullWidth
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={this.validateAndCreateSecurityAdaptor}
                                >
                                Submit
                                </Button>
                            </ThemeProvider>
                        </ThemeProvider>
                    </Paper>
                </div>
                {this.state.error === true && (
                <ErrorMessageAlert
                    open={this.state.error}
                    handleClose={this.closeError}
                    errorInfo={this.state.error_message}
                />
                )}
            </div>
        );
    }
}

export default withStyles(styles)(CreateSecurityAdaptor);
